import { observer } from "mobx-react";
import { useEstimateStructure } from "@tools";
import { TimelineSectionChart } from "../../TimelineSectionChart/TimelineSectionChart";

export const TimelineSectionContents = observer(() => {
  const structure = useEstimateStructure();

  const sections = structure.currentTimeline?.visibleSections || [];

  return sections.map((section, index) => (
    <TimelineSectionChart key={section.id} section={section} index={index} />
  ));
});
